import { render, staticRenderFns } from "./index2.vue?vue&type=template&id=4d5b038a&scoped=true"
import script from "./index2.vue?vue&type=script&lang=js"
export * from "./index2.vue?vue&type=script&lang=js"
import style0 from "./index2.vue?vue&type=style&index=0&id=4d5b038a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d5b038a",
  null
  
)

export default component.exports